import { Grid, Divider } from "@mui/material";
import React from "react";

import AddEditVatBaseRow from "./AddEditVatBaseRow/AddEditVatBaseRow";
import {
  Container,
  HeaderName,
  ActionsBlock,
  RowContainer,
  MainContainer,
  AddRowContainer,
  CellBlock,
  CellSimpleText,
  AmountBlock,
  AmountContainer,
  AmountSpan,
  AmountCurrency,
} from "./styles";

import { VendorInvoiceVATBaseRef } from "../../../../../models/legal-entity-vendors/vendor-invoices";
import { TransactionDTO } from "../../../../../models/transactions";
import ConfirmationRemoveItemDialog from "../../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const VatCountries = ({ transaction: { vendorInvoice }, readOnly = false, handleChange }: Props) => {
  const handleChangeVat = (value: VendorInvoiceVATBaseRef, idx: number): void => {
    if (vendorInvoice) {
      idx < 0
        ? handleChange &&
          handleChange("vendorInvoice", {
            ...vendorInvoice,
            vatBases: [...(vendorInvoice.vatBases ?? []), value],
          })
        : handleChange &&
          handleChange("vendorInvoice", {
            ...vendorInvoice,
            vatBases: [
              ...(vendorInvoice.vatBases ? vendorInvoice.vatBases.slice(0, idx) : []),
              value,
              ...(vendorInvoice.vatBases ? vendorInvoice.vatBases.slice(idx + 1) : []),
            ],
          });
    }
  };

  const handleRemoveVat = (idx: number): void => {
    if (vendorInvoice)
      handleChange &&
        handleChange("vendorInvoice", {
          ...vendorInvoice,
          vatBases: [
            ...(vendorInvoice && vendorInvoice.vatBases ? vendorInvoice.vatBases.slice(0, idx) : []),
            ...(vendorInvoice && vendorInvoice.vatBases ? vendorInvoice.vatBases.slice(idx + 1) : []),
          ],
        });
  };

  return (
    <Grid>
      {vendorInvoice && vendorInvoice.vatCountry && (
        <MainContainer>
          <div>
            <Container>
              <CellBlock>
                <HeaderName>VAT Country</HeaderName>
              </CellBlock>
              <CellBlock>
                <AmountBlock>
                  <HeaderName>Base</HeaderName>
                </AmountBlock>
              </CellBlock>
              <CellBlock>
                <HeaderName>VAT type %</HeaderName>
              </CellBlock>
              <CellBlock>
                <AmountBlock>
                  <HeaderName>VAT amount</HeaderName>
                </AmountBlock>
              </CellBlock>
              {!readOnly && (
                <ActionsBlock>
                  <HeaderName>Actions</HeaderName>
                </ActionsBlock>
              )}
            </Container>

            <Divider sx={{ width: readOnly ? "600px" : "700px" }} />

            {Array.isArray(vendorInvoice.vatBases) &&
              vendorInvoice.vatBases.map((vat, idx) => {
                return (
                  <RowContainer key={idx}>
                    <CellBlock>
                      <CellSimpleText>{vendorInvoice.vatCountry ? vendorInvoice.vatCountry.code : ""}</CellSimpleText>
                    </CellBlock>
                    <CellBlock>
                      <AmountContainer>
                        <AmountSpan title={`${vat && vat.base !== undefined ? (+vat.base).toLocaleCustom() : ""}`}>
                          {vat && vat.base !== undefined ? (+vat.base).toLocaleCustom() : ""}
                        </AmountSpan>
                        <AmountCurrency>{vendorInvoice.currency ? vendorInvoice.currency.code : ""}</AmountCurrency>
                      </AmountContainer>
                    </CellBlock>
                    <CellBlock>
                      <CellSimpleText>{vat && vat.rate !== undefined ? `${vat.rate}%` : ""}</CellSimpleText>
                    </CellBlock>
                    <CellBlock>
                      <AmountContainer>
                        <AmountSpan title={`${vat && vat.amount !== undefined ? (+vat.amount).toLocaleCustom() : ""}`}>
                          {vat && vat.amount !== undefined ? (+vat.amount).toLocaleCustom() : ""}
                        </AmountSpan>
                        <AmountCurrency>{vendorInvoice.currency ? vendorInvoice.currency.code : ""}</AmountCurrency>
                      </AmountContainer>
                    </CellBlock>
                    {!readOnly && (
                      <ActionsBlock>
                        <AddEditVatBaseRow
                          handleChangeVat={(value) => handleChangeVat(value, idx)}
                          vat={vat}
                          vendorInvoice={vendorInvoice}
                        />
                        <ConfirmationRemoveItemDialog
                          index={idx}
                          handleRemove={handleRemoveVat}
                        />
                      </ActionsBlock>
                    )}
                  </RowContainer>
                );
              })}
          </div>

          {!readOnly && (
            <>
              <Divider sx={{ width: "700px" }} />

              <AddRowContainer>
                <AddEditVatBaseRow
                  handleChangeVat={(value) => handleChangeVat(value, -1)}
                  vendorInvoice={vendorInvoice}
                />
              </AddRowContainer>
            </>
          )}
        </MainContainer>
      )}
    </Grid>
  );
};

export default VatCountries;
